import React from "react"
import {FormattedMessage} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BaseComponent from "../base-component";

class AttachmentsList extends BaseComponent {

    render() {
        const { contentUnit } = this.props;
        const { attachments } = contentUnit;

        if (!contentUnit || !contentUnit.attachments || contentUnit.attachments.length === 0) {
            return null;
        }

        return (
            <div className=''>
                <hr/>
                <h3><FormattedMessage id='app.content_units.attribute.attachments'/></h3>
                {
                    attachments.map((attachment) => (
                        <p className={''} key={attachment.id}>
                            <strong>{attachment.name}</strong><br/><a href={attachment.url} target='_blank'><FontAwesomeIcon icon={['far', 'download']}/> {attachment.filename}</a><br/>
                            {attachment.description}
                        </p>
                    ))
                }
            </div>
        )
    };
}

export default AttachmentsList;
